<template>
  <footer class="footer footer-transparent">
    <div class="container">
      <div class="text-center copyright" :class="{ light: mode==='light', absolute }">
        <fa-icon icon="code" /> with <fa-icon icon="heart" class="heart" /> by <a target="_blank" href="http://fentrica.com">Fentrica</a>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
@import "larva/_variables.scss";
.footer {
  padding: 2rem 0;
}
.footer .copyright, .footer .copyright a {
    color: $text-color;
  .heart {
    color: $danger;
  }
}
.footer .copyright.light, .footer .copyright.light a {
  color: $text-color-step-1000;
}
.copyright.absolute {
  position: absolute;
}

</style>
<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faHeart, faCode,
} from '@fortawesome/free-solid-svg-icons';

library.add(faHeart, faCode);

export default {
  props: ['mode', 'absolute'],

};
</script>
